<template>
<transition name="slide-fade">
        <div  v-if="transaction!==undefined">
            <div class="row">
                <div class="col-lg-7 col-md-7 col-xs-12 gate pt-15" style="max-height: 100vh;" :style="{background:'url(../../public/images/samples/Login_bg.jpg) center no-repeat',backgroundSize:'cover'}">
                    <div class="row">
                        <!-- invoice table -->
                        <div class="top-second-gate-header text-center col-12 d-block d-sm-block d-md-none" :style="{background: '#1a1e31'}">
                            <span v-if="rate"  class="htitle"> {{$t('payments.transaction_fees_has_been_applied',{rate:rate})}}</span>
                            <span v-else class="htitle">{{$t('payments.fees_info')}}</span>
                        </div>
                        <div v-if="marchandIsInSandboxMode(transaction)" class="top-second-gate-header text-center col-12 d-block d-sm-block d-md-none" :style="{background: '#ce9d2f'}">
                            <span  class="htitle">{{$t('payments.sandbox_mode')}}</span>
                        </div>
                        <div class="top-gate-header text-center col-12 pb-10 d-block d-sm-block d-md-none" :style="{background: getColor()+'!important'}">
                            <div class="paiement_price_box">
                                <span class="htitle"> {{$t('payments.amount_to_pay')}} :</span> <br>
                                <span class="price">{{(transaction._amount+fees)}} ({{transaction.invoice.currency}})</span>
                            </div>
                        </div>
<div class="offset-lg-2 offset-md-2 col-lg-8 col-md-8 col-xs-12 col-sm-12 globalPaiment" style="background: #fff">
    <div class="text-center col-12 col-lg-12  shop-info_mini d-block d-sm-block d-md-none">
        <div class="img-header-gate_mini mt-7" >
            <img style="cursor: pointer" @click="goToMarchandUrl(transaction)" v-if="transaction._store.logo_url && transaction._store.logo_url.length"  v-lazy="transaction._store.logo_url" alt="logo intram" class="card-image" :style="{borderColor: getColor()+'!important'}">
            <span style="cursor: pointer" @click="goToMarchandUrl(transaction)" v-else class="texteLogo" :style="{color: getColor()+'!important'}">{{transaction._store.name.charAt(0).toUpperCase()}}</span>
        </div>
    </div>


    <div>
        <!--    Transaction fail-->
        <div class="col-12 text-center pt-12" v-if="submitted && status!=='SUCCESS'">
            <img v-lazy="'/images/paiement-status/paiement-error.png'" width="200px" alt="payment">
            <div class="text-uppercase paiement-error pt-6">{{$t('payments.error')}}</div>
            <div class="text-center pt-6">
                <a href="#" @click="reloadPage()" class="btn btn-md text-uppercase" :style="{background:'#801513',color:'#fff',fontWeight:'bold',borderRadius:'0px'}">{{$t('payments.retry')}}</a>
            </div>
        </div>
        <!--    Transaction success-->
        <div class="col-12 text-center pt-12" v-if="submitted && status==='SUCCESS'">
        
            <img v-lazy="'/images/paiement-status/paiement-sucess.png'" width="200px" alt="">
            <div class="text-uppercase paiement-sucess pt-6">{{$t('payments.proceed_successfully')}} </div>
            <div class="text-center pt-6">
                <a @click.prevent="getCallBackUrl()" class="btn btn-md text-uppercase" :style="{background:getColor()+'!important',color:'#fff',fontWeight:'bold',borderRadius:'0px'}">{{$t(finishBtnTitle)}}</a>
            </div>
        </div>
        <!--    Check your phone-->
        <div class="col-12 text-center pt-12" v-if="submitting && manual_pay==='Mobile'">
            
            <img class="pulse" v-lazy="'/images/paiement-status/check.jpg'" width="200px" alt="">
            <div class="col-12 text-center text-uppercase">
                <img src="/loaders/loader.gif" alt="" width="20px">  {{$t('transaction_loading')}} ....
            </div>
            <div class="text-uppercase paiement-sucess pt-6">{{$t('payments.check_phone')}} </div>
        </div>
    </div>

                    <div v-if="!getSetting('dpqr')">
                        <div  class=" col-12 " v-if="transaction && !submitted && paid_by==='qr'">
                            <h3 class="text-center select_paiement_text">
                                {{$t('payments.pay_by_qrcode')}}
                            </h3>
                            <div v-if="error" class="card-body px-5 py-5">
                                <v-alert
                                        dense
                                        outlined
                                        type="error">
                                    {{message}}
                                </v-alert>
                            </div>
                            <div class="text-center mt-2 col-12">
                                <div class="qrCode text-center" >
                                    <img  v-if="transaction._qrcode!==null && transaction._qrcode!==undefined" v-lazy="transaction._qrcode" alt="qr code transaction" class="">
                                </div>
                                <img v-lazy="'/images/qr.png'" alt="qr-code" class="card-image ">
                                <br>
                                <span>
                                            {{$t('payments.scan_code')}}
                                        </span>
                            </div>
                            <div class="text-center mt-2">
                                <a class="text-center another_paiement_choice" v-if="paid_by!=='manuel'" @click="setPaidBy('manuel')">{{$t('payments.use_mobile_money_or_bank')}} </a>
                            </div>
                        </div>
                    </div>
                   <div class="pt-0" >
                        <div v-if="transaction && !submitted && paid_by==='manuel'"  class="manual_paiement">
                            <div class="row text-center" v-if="showSelectMeanMethod && submitting===false ">
                            <div class="col-6 text-center">
                                 <v-card   class="card-btn" href="#" @click="selectMeanType('Mobile')"  :style="{background: manual_pay==='Mobile' ? getColor()+'!important' :'#ddd',color: manual_pay==='Mobile' ? '#f8f8f8' :'',}">
                                    {{$t('mobile_money')}}
                                </v-card>
                            </div>
                            <div class="col-6 text-center">
                                <v-card    class="card-btn" href="#" @click="selectMeanType('Banque')"  :style="{background: manual_pay==='Banque' ? getColor()+'!important' :'#ddd',color: manual_pay==='Banque' ? '#f8f8f8' :'',}">
                                    {{$t('bank_card')}}
                                </v-card>
                            </div>
                        </div>
                            <!--<vue-friendly-iframe src="http://gim.barakamoney.net/Ecom-HostedPaymentPage/SecureRedirectAuthLink?AccessKey=AsimDmofBPDfolqZEBWtkJg41g37uTykgXo1u8I"  ></vue-friendly-iframe>-->
                            <!--<iframe name="iframe1" src="http://gim.barakamoney.net/Ecom-HostedPaymentPage/SecureRedirectAuthLink?AccessKey=AsimDmofBPDfolqZEBWtkJg41g37uTykgXo1u8I"></iframe>-->

                            <div v-if="!getSetting('dpm')">
                                <v-form ref="form" @submit.prevent="pay" style="background: #fff" v-show="manual_pay==='Mobile' && !submitting" v-model="valid">
                                    <v-container>
                                        <v-row>
                                            <v-col cols="6">
                                                <v-text-field
                                                        style="border-radius: 3px!important;"
                                                        v-model="last_name"
                                                        label="Nom"
                                                        :rules="rules.lastNameRules"
                                                        type="text" solo/>
                                            </v-col>
                                            <v-col cols="6">
                                                <v-text-field
                                                        style="border-radius: 3px!important;"
                                                        v-model="first_name"
                                                        label="Prénom"
                                                        :rules="rules.firstNameRules"
                                                        type="text" solo/>
                                            </v-col>
                                        </v-row>
                                        <v-row>

                                            <v-col :cols="12">
                                                <vue-phone-number-input
                                                        @update="phoneNumberEntered"
                                                        :translations="translations"
                                                        :error="!phoneNumberIsValid"
                                                        :only-countries="preferedCountries"
                                                        :preferred-countries="preferedCountries"
                                                        default-country-code="BJ"
                                                        :valid-color="getColor()"
                                                        v-model="phoneNumber"/>
                                                <img class="mean_logo" v-if="mean_logo" v-lazy="mean_logo">
                                            </v-col>
                                            
                                            

                                        </v-row>
                                        <v-col cols="12" class="text-center">
                                            <v-btn type="submit" class="paid_btn" :disabled="!valid || !phoneNumberIsValid" :color="getColor()+'!important'" :loading="submitting">
                                                {{$t('payments.pay')}} {{(transaction._amount+fees)}} {{transaction.invoice.currency}}
                                                <v-icon>mdi-check-circle</v-icon>
                                            </v-btn>
                                        </v-col>
                                    </v-container>
                                </v-form>
                            </div>
                            <div v-if="!getSetting('dpb')">
                                <v-form id="payment-form" ref="form"  style="background: #fff" v-model="cardFormIsValid" v-show="manual_pay==='Banque'">
                                    <v-container>
                                        <v-row>
                                            <v-col cols="6">
                                                <v-text-field
                                                        style="border-radius: 0!important;"
                                                        v-model="last_name"
                                                        label="Votre nom"
                                                        :rules="[rules.required]"
                                                        type="text" solo/>
                                            </v-col>
                                            <v-col cols="6">
                                                <v-text-field
                                                        style="border-radius: 0!important;"
                                                        v-model="first_name"
                                                        label="Votre prénom"
                                                        :rules="[rules.required]"
                                                        type="text" solo/>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12">
                                                <v-text-field
                                                        style="border-radius: 0!important;"
                                                        v-model="email"
                                                        :rules="[rules.email]"
                                                        label="Votre adresse mail"
                                                        type="email" solo>
                                                </v-text-field>
                                            </v-col>
                                        </v-row>
                                       
                                        <div id="card-element"><!--Stripe.js injects the Card Element--></div>
                                        <p style="color: #b71c1c" id="card-error" role="alert"></p>
                                        <v-col cols="12" class="text-center">
                                            <v-btn @click.prevent="payWithCard" class="paid_btn" :disabled="!cardFormIsValid || !cardIsValid" :color="getColor()+'!important'" :loading="submitting">
                                                {{$t('payments.pay')}} {{(transaction._amount+fees)}} {{transaction.invoice.currency}}
                                                <v-icon>mdi-check-circle</v-icon>
                                            </v-btn>
                                        </v-col>
                                        <p class="result-message hidden">
                                            Payment succeeded, see the result in your
                                            <a href="" target="_blank">Stripe dashboard.</a> Refresh the page to pay again.
                                        </p>
                                    </v-container>
                                </v-form>
                            </div>
                            <div class="text-center col-12 pb-0" v-if="!getSetting('dpqr')">
                                <a class="text-center another_paiement_choice" v-show="paid_by!=='qr'" @click="setPaidBy('qr')">{{$t('payments.use_app')}}</a>
                            </div>
                    </div>
                    </div>
                    </div>
                        <div class="col-xs-12  col-lg-12 items_display_mini d-block d-sm-block d-md-none text-left" :style="{color: '#1e3551'}">
                            <h3 class="col-12 col-lg-12 itemsTilte" :style="{background: getColor()+'!important'}" @click="detailsAction()"><span class="text-details"> <i class="mdi mdi-note-multiple-outline"></i> {{$t('payments.transaction_details')}}</span> 
                                <a @click="generateReport()" href="#" class="float-right close_details" :style="{color: getColor()+'!important'}"><i class="mdi mdi-note-outline"></i> {{$t('payments.bill')}}</a>
                            </h3>
                            <div class="col-12 col-lg-12 detail_paiement">
                                <table class="table table-responsive table-no-bordered" v-if="transaction.invoice.items.length>0">
                                    <thead><th>{{$t('name')}}</th><th>{{$t('quantity')}}</th><th>{{$t('price')}}</th><th>{{$t('total')}}</th></thead>
                                    <tbody>
                                    <tr v-for="item in transaction.invoice.items" :key="item._id"><td>{{item.name}}</td><td>{{item.quantity}}</td><td>{{item.price}}</td><td>{{item.total_amount}} {{transaction.invoice.currency}}</td></tr>
                                    </tbody>
                                    <tfoot>
                                    <tr><td colspan="3">{{$t('total')}}</td><td>{{getInvoiceTotal(transaction.invoice.items)+' ('+transaction.invoice.currency+')'}}</td></tr>
                                    <tr v-for="taxe in transaction.invoice.taxes" :key="taxe._id">
                                        <td colspan="3">{{taxe.name}}</td>
                                        <td>{{taxe.amount}} {{transaction.invoice.currency}}</td>
                                    </tr>
                                    <tr><td colspan="3">{{$t('payments.total_to_pay')}} </td><td>{{transaction._amount+' ('+transaction.invoice.currency+')'}} </td></tr>
                                    <tr style="background: #CCCCCC" v-for="(data,index) in transaction.invoice.custom_datas" :key="index">
                                        <td>{{getItemKeyAndValue(data).key}}</td>
                                        <td>{{getItemKeyAndValue(data).value}}</td>
                                    </tr>
                                    </tfoot>
                                </table>
                                <div  v-for="(data,index) in transaction.invoice.custom_datas" :key="index">
                                    <span>{{getItemKeyAndValue(data).key}} : </span>
                                    <span>{{getItemKeyAndValue(data).value}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-5 col-md-5 col-xs-12 d-none d-sm-none d-md-block text-center pt-0" style="background: rgba(0,0,0,0.8);max-height: 100vh;overflow:hidden">
                    <div class="row">
                        <div class="text-center col-12 col-lg-12  shop-info">
                            <div class="img-header-gate mt-7">
                                <img style="cursor: pointer" @click="goToMarchandUrl(transaction)" v-if="transaction._store.logo_url && transaction._store.logo_url.length"  v-lazy="transaction._store.logo_url" alt="logo intram" class="card-image ">
                                <span style="cursor: pointer" @click="goToMarchandUrl(transaction)" v-else class="texteLogo" :style="{color: 'black'}">{{transaction._store.name.charAt(0).toUpperCase()}}</span>
                            </div>
                            <span class="text-uppercase shop_name text-center" style="cursor: pointer" @click="goToMarchandUrl(transaction)">
                            {{transaction._store.name}} </span>
                        </div>
                        <div class="top-gate-header text-center col-12" :style="{background: getColor()+'!important'}">
                            <div class="paiement_price_box">
                                <span class="htitle"> {{$t('payments.amount_to_pay')}}</span> <br>
                                <span class="price">{{(transaction._amount+fees)}} ({{transaction.invoice.currency}})</span>
                            </div>
                            <div class="text-center col-12 col-lg-12  ml-10  d-block d-sm-block d-md-none  shop-info">
                                <div class="img-header-gate_mini float-left" >
                                    <img style="cursor: pointer" @click="goToMarchandUrl(transaction)" v-if="transaction._store.logo_url && transaction._store.logo_url.length" v-lazy="transaction._store.logo_url" alt="logo intram" class="card-image " :style="{borderColor: getColor()+'!important'}">
                                    <span style="cursor: pointer" @click="goToMarchandUrl(transaction)" v-else class="texteLogo" :style="{color: getColor()+'!important'}">{{transaction._store.name.charAt(0).toUpperCase()}}</span>
                                </div>
                                <div class="text-uppercase col-12 col-lg-12 shop_name_mini mt-1 text-left">&nbsp;&nbsp;&nbsp;<span style="cursor: pointer" @click="goToMarchandUrl(transaction)">{{transaction._store.name}}</span> </div>
                            </div>
                        </div>
                        <div class="top-second-gate-header text-center col-12 " :style="{background: '#1a1e31'}">
                            <span v-if="rate"  class="htitle"> {{$t('payments.transaction_fees_has_been_applied',{rate:rate})}}</span>
                            <span v-else class="htitle">{{$t('payments.fees_info')}}</span>
                        </div>
                      <div class="top-second-gate-header text-center col-12" v-if="marchandIsInSandboxMode(transaction)" :style="{background: '#f5b94a'}">
                            <span class="htitle">{{$t('payments.sandbox_mode')}}</span>
                        </div>
                        <div class="col-xs-12  col-lg-12  text-left" :style="{color: '#1e3551'}">
                            <div class="row">
                            <h3 class="col-12 col-lg-12 itemsTilte" :style="{background: getColor()+'!important'}" ><span class="text-details" @click="detailsAction()"> <i class="mdi mdi-note-multiple-outline"></i> {{$t('payments.transaction_details')}}</span> 
                            <a @click="generateReport()" href="#" class="float-right close_details" :style="{color: getColor()+'!important'}"><i class="mdi mdi-note-outline"></i> {{$t('payments.bill')}}</a></h3>
                            <div class="col-12 col-lg-12 pb-0 detail_paiement" style="max-height: 200px;overflow-y: auto">
                                <table class="table table-responsive table-no-bordered" v-if="transaction.invoice.items.length>0">
                                    <thead><th>{{$t('name')}}</th><th>{{$t('quantity')}}</th><th>{{$t('price')}}</th><th>{{$t('total')}}</th></thead>
                                    <tbody>
                                    <tr v-for="item in transaction.invoice.items" :key="item._id">
                                        <td>{{item.name}}</td>
                                        <td>{{item.quantity}}</td>
                                        <td>{{item.price}}</td>
                                        <td>{{item.total_amount}} {{transaction.invoice.currency}}</td>
                                    </tr>
                                    </tbody>
                                    <tfoot>
                                    <tr><td colspan="3">{{$t('total')}}</td><td>{{getInvoiceTotal(transaction.invoice.items)+' ('+transaction.invoice.currency+')'}}</td></tr>
                                    <tr v-for="taxe in transaction.invoice.taxes" :key="taxe._id">
                                        <td colspan="3">{{taxe.name}}</td>
                                        <td>{{taxe.amount}} {{transaction.invoice.currency}}</td>
                                    </tr>
                                    <tr><td colspan="3">{{$t('payments.total_to_pay')}} </td><td>{{transaction._amount+' ('+transaction.invoice.currency+')'}} </td></tr>
                                    </tfoot>
                                </table>
                                <div  v-for="(data,index) in transaction.invoice.custom_datas" :key="index">
                                    <span>{{getItemKeyAndValue(data).key}} : </span>
                                    <span>{{getItemKeyAndValue(data).value}}</span>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
           </div>   
        </div>
</transition>
</template>
<script>
    /* eslint-disable */
    import {mapState} from "vuex";
    import helpers from "../../mixins/helpers";
    export default {
        name: "PaymentGateFirst",
        mixins:[helpers(this)],
        data (){
            return {
                stripe:undefined,
                finishBtnTitle:'payments.finished',
                translations:{
                countrySelectorLabel: 'Code pays',
                countrySelectorError: 'Choisir un pays',
                phoneNumberLabel: 'Numéro de téléphone',
                example: 'Exemple :'
            },
                defaultColor:"#29B3A6",
                logo_url:'/images/logo_large.png',
                mean_logo:undefined,
                phoneNumber:'',
                cardIsValid:false,
                phoneNumberIsValid:false,
                country_code:'',
                country_phone_code:'',
                submitting:false,
                submitted:false,
                fees:0,
                rate:undefined,
                cardFormIsValid:false,
                valid:false,
                mean:'mobile',
                status:'PENDING',
                card_number:'',
                card_expiry_month:'',
                card_expiry_year:'',
                card_cvv2:'',
                card_expiration:'',
                card_url_payment:undefined,
                rules: {
                    required: v => !!v ||  this.$t('field_required'),
                    min: v => !!v && v.length >= this.getSetting('nmcpw') || this.$t('min_8_caracters',{number:this.getSetting('nmcpw')}),
                    max: v => !!v && v.length >= 16 || this.$t('min_8_caracters',{number:16}),
                    match: v => v === this.password || this.$t('password_mismatch'),
                    email: v => v.match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/) ||  this.$t('invalid_email'),
                    tel: v => v.match(/^[+]*[(]?[0-9]{1,4}[)]?[-\s/0-9]*$/g) ||  this.$t('invalid_phone'),
                    //email: v => (v.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) ||  this.$t('invalid_email'),
                    //validCardNumber : v => card.isValid(v) ||  'Numéro de carte invalid',
                },
                num_source:'',
                first_name:null,
                last_name:null,
                email:'',
                errors:{},
            }
        },
        mounted (){

        },
        computed:{
            ...mapState('payments/',['transaction','error','message','means_of_paiements','client_secret']),
            ...mapState('generalsettings/',['generals','manual_pay','paid_by','showSelectMeanMethod']),
            preferedCountries(){
                let array = [];
                this.means_of_paiements.forEach((mean)=>{
                    if (mean._type=== process.env.VUE_APP_MOBILE){
                        array.push(mean._country._code.toUpperCase())
                    }
                });
                return array;
            },

        },

        methods:{
 generateReport () {
                this.$parent.generateReport()
            },
            getInvoiceTotal(items){
                let sum  =0;
                items.forEach ((item)=>{
                    let amnt = (item.total_amount)?parseInt(item.total_amount):0;
                    sum+=amnt;
                });
                return sum;
            },
        },

    }

</script>

<style scoped>
   .paiement-error{
        font-weight: bold;
        padding: 10px;
                color: rgb(158, 158, 158);

    }
    .paiement-sucess{
        font-weight: bold;
        color: rgb(158, 158, 158);
        font-weight: 500;
    }
.qrCode{
    position: absolute;
width: 100%;
    padding-top: 68px;
    padding-right: 20px;
}
    .v-sheet.v-toolbar:not(.v-sheet--outlined), .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot{
        border-radius: 3px !important;
    }
    .texteLogo{
        cursor: none;
        font-size: 50pt;
        font-weight: bold;
    }
    .mean_logo{
        position: absolute;
        
        width: 50px;
        padding-top: 2px;
    background: transparent;
    padding: 5px;
    border-radius: 5px;
    right: 20px;
    top:15px;
    z-index: 99999999;
        object-fit: contain;
    }
    .logoDash{
        margin-top: -5px;
    }

    .v-card > *:last-child:not(.v-btn):not(.v-chip){
        border-radius: 100% !important;
    }
    .Mobile img{
        width: 100%;
        height: 100%;
        border-radius: 100%;
    }
    .manual_paiement{
        margin-left: 0!important;
    }
.card-btn{
    width: 100% !important;
    height: 40px;
    margin: 0 !important;
    padding: 0 10px !important;
    font-size: 12pt;
    line-height: 40px;
    font-weight: bold;
}

    .paid_btn{
        border-radius: 6px !important;
        margin-bottom: 0!important;
    }

    .shop-info{
        height: 180px;
        text-align: center;padding: 0;
        background: rgba(12,21,32,0.5);
        line-height: 90px;
    }
    .shop-info_mini{
        position: absolute;
        top: -80px;
        text-align: center;padding: 0;
    }
    .img-header-gate{
        width: 120px;
        height: 120px;
        line-height: 100px;
        border: 0;
        background: #fff;
        border-radius: 100%;
        padding: 10px;
        text-align: center;
        position: relative;
        display: inline-block;
    }
    img-header-gate{
        padding: 20px;
    }
    .img-header-gate img{
        width: 100px;
        height: 100px;
        border-radius: 50%;
    }
    .text-details{
        font-size: 12pt;
    }
    .detail_paiement{
        display: none;
        padding-top: 15px;
        background: #fff;
    }
    .close_details{
        font-size: 12pt;
        background: rgb(211, 232, 210);
        padding: 5px 12px;
        cursor: pointer;
        margin-right: 30px;
        margin-bottom: 0;
        border-radius: 6px;
    }
    .itemsTilte{
        color: #fff;
        padding: 7px 12px;
        cursor: pointer;
        margin-bottom: 0;
    }
    .items_display{
        position: fixed;
        bottom: 0;
        padding: 0 5px;
        margin: 0;
        width: 69% !important;
    }
    .items_display_mini{
        z-index: 10;
        position: fixed;
        bottom: 0;
        padding: 0;
        margin: 0;
        margin-left: 15px;
        width: 100% !important;
    }

    .footer-gate-payment ,.footer-gate-payment_down{
        padding: 0 10px;
        position: fixed;
        top: 0;
        width: 100%;
        margin-left: 0;
    }
    @media (max-width: 991px) {
        .qrCode{
            position: absolute;

        }
        .gate{
            padding-top: 0 !important;
        }
        .globalPaiment{
            padding-top: 60px;
            padding-bottom: 60px;
        }
        .texteLogo{
            font-size: 20pt;
            display: inline;
        }
        .footer-gate-payment ,.footer-gate-payment_down{
            top: 97vh;
            z-index: 99999;
        }

        .another_paiement_choice{
            font-size: 8pt;
        }
        .select_paiement_text{
            font-size: 10pt;
        }
        .text-details{
            font-size: 8pt !important;
            margin-top: -10px;
        }
        .close_details{
            font-size: 8pt;
            margin-right: 0;
            margin-top: -2px !important;
            padding: 2px 5px;
        }
        .itemsTilte{
            padding: 5px 12px;
            font-size: 10pt;
        }
        .img-header-gate_mini{
            /*width: 120px;*/
            height: 120px;
            background: transparent;
            padding: 5px;
            text-align: center;
            position: relative;
            padding-right: 30px;
        }
        .img-header-gate_mini img{
            width: 100px;
            height: 100px;
            border-radius: 50%;
                border: 10px solid #1e3551;
        }
        .shop_name_mini{
            font-weight: 500;
            font-size: 12pt;
            padding: 15px 20px;
            color: #fff;
        }
        .footer-gate-payment{
            margin-left: 15px;
        }
    }
    .another_paiement_choice{
        text-decoration: underline !important;
    }
.gate{
    padding-top: 0;
    background: #f8f8f8;
    min-height: 100vh;
}


    .footer-gate-payment img{
        width: 50px;
    }
.top-second-gate-header{
    color: #fff;
    padding: 0 10px;
}
.top-second-gate-header .htitle{
    font-size: 7pt;
}
    .top-gate-header{
        color: #fff;
        padding: 20px;
        margin-top: 0;
    }

    .portail_text{
        font-size: 25pt;
        font-weight: 500;
        padding: 10px;
    }
    .shop_name{
        font-weight: 500;
        font-size: 20pt;
        padding: 15px;
        color: #fff;
    }
    .paiement_price_box{
    }
    .paiement_price_box .htitle{
        font-size: 8pt;
        font-weight: 500;
    }
     .paiement_price_box .price{
         font-size: 20pt;
         font-weight: bold;
    }
    .payment-mean-img{
        height: 10%;
    }
   .card-btn{
      padding: 30px;
       margin: 15px;
       text-decoration: none;
   }
    #loginCarousel{
        height: 100vh;
    }
    .loginPanel{
        background: url("../../../public/images/loginBack.jpg") center no-repeat;
        background-size: cover;
    }
    .carousel-inner{
        height: 100%;
    }
    .carousel-inner{
        background: url("../../../public/images/reserveBank.jpg") center no-repeat;
        background-size: cover;
        text-align: center;
    }
    .qrPanel{
        position: absolute;
        top: 35vh;
        left: 17vw;
        width: 350px;
        padding: 20px;
        background: rgba(46, 96, 139, 0.67);
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.25);
        border-radius: 23px;
    }
    .qrPanel img{
        width: 70px;
    }

    .qrPanel span{
        padding: 20px;
        margin-top: 20px;
        font-size: 11pt;
        font-weight: bold;
        text-transform: uppercase;
        color: #fff;
    }
    .enter-btn{
        margin-top: 20px;
        padding: 15px 25px;
        border-radius: 50px;
        color: rgba(41, 179, 166, 1);
        background: #fff;
        border: 1px solid rgba(41, 179, 166, 1);
        cursor: pointer;
    }


    .carouselPanel{
        padding: 0;
    }
    .card-image{width: 250px;background: #fff}
    .auth-pages .form-group .form-control{border-radius: 50px;}
    .wrapper{
        margin-top: 50px;
        margin-bottom: 50px;
    }


    .auth-pages .form-group .form-control:focus{
        transition-duration: 5ms;
        border: 1px solid rgba(41, 179, 166, 1);
    }
    .auth-pages .form-group .form-control:hover{
        border: 1px solid rgba(41, 179, 166, 1);
        transition-duration: 5ms;
    }




</style>
